import { api } from './api';
import { ResponseType } from '../types/shared.types';
import {
  LocationAlerts,
  LocationServiceValue,
  LocationServiceValueParams,
} from '../types/locationInsights.types';

/**
 * Location Details: what the client made and saved with us and what we made
 * from it, for one period or, without `from` and `to`, all time. 404 for a location that does not exist.
 */
export const getLocationServiceValue = (
  locationId: number | string,
  params: LocationServiceValueParams
) =>
  api.get<ResponseType<LocationServiceValue>>(
    `/v1/locations/${locationId}/service-value`,
    { params }
  );

/**
 * Location Details: what is missing on file plus the location's open system
 * problems. Worked out on every call, so refetch it after anything that could
 * change either.
 */
export const getLocationAlerts = (locationId: number | string) =>
  api.get<ResponseType<LocationAlerts>>(`/v1/locations/${locationId}/alerts`);
